<template>
    <img
        v-bind="$attrs"
        ref="img"
        v-bind:src="internalSrc"
        v-bind:style="placeholderStyle" />
</template>

<script>
    export default {
        props: {
            src: { type: String, required: true },
            placeholderWidth: { type: Number, required: false, default: 0 },
            placeholderHeight: { type: Number, required: false, default: 0 }
        },
        data() {
            return {
                imageInViewport: false,
                imageLoaded: false,
                observer: null
            };
        },
        computed: {
            internalSrc() {
                return this.imageInViewport ? this.src : null;
            },
            placeholderStyle() {
                // Styles defined by the parent will overwrite this
                if (!this.imageLoaded) {
                    return `width: ${this.placeholderWidth}px;` + `height: ${this.placeholderHeight}px;` + "opacity: 0";
                }
                return "";
            }
        },
        beforeUnmount() {
            if (this.observer) {
                this.observer.disconnect();
            }
        },
        mounted() {
            this.$refs.img.onload = () => {
                this.imageLoaded = true;
            };

            // Lazy load images; wait until they come into the viewport before trying to load
            if (typeof IntersectionObserver !== "function") {
                this.imageInViewport = true;
                return;
            }

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.imageInViewport = true;
                        this.observer.disconnect();
                    }
                });
            });
            this.observer.observe(this.$el);
        }
    };
</script>
